<template>
<v-app>
<v-main>

     <div
        style="text-align: center; margin-top: 30px; margin-bottom: 30px;"
    >
        <img 
            src="@/assets/redchirp-logo-square-center.png" 
            style="width: 300px"
        />

    </div>

    <div
        style="text-align: center;"
    >
        You will be re-directed to a secure payment form shortly.<br/>
    </div>
   
  
</v-main>


  <m-global-spinner/>
  <m-global-snackbar/>
  <m-global-alert/>
  <m-global-confirm/>
  <m-global-prompt/>

</v-app>
</template>

<script>
export default {
    mounted () {
        
        let after_url = window.location.origin+this.$router.resolve({
                'name': 'red-chirp-provide-payment-method-thank-you',
                'params' : {
                }
            }).href;
        
        this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/organizations/red-chirp-payments/start-add-stripe',
            
                'params' : {
                        'after_url': after_url,
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        window.location = data.url;
                    },
            
                'on_error': 'Unable to add payment method.',
            }); 
    },

   
}
</script>

<style lang="scss" scoped>
</style>